/**
 * Ask ABHI palette — neutral and quiet, with the ABHI logo's purple used
 * sparingly as the single accent (launcher, badges, citations, spinners).
 */

export const INK = '#18181b';
export const TEXT = '#27272a';
export const MUTED = '#71717a';
export const SUBTLE = '#a1a1aa';
export const SURFACE = '#f4f4f5';
export const PANEL = '#ffffff';
export const PANEL_TINT = '#fafafa';
export const LINE = 'rgba(24, 24, 27, 0.08)';
export const LINE_STRONG = 'rgba(24, 24, 27, 0.14)';
/** The logo's violet (#7C20F4). DEEP is for text on TINT (AA contrast). */
export const ACCENT = '#7c20f4';
export const ACCENT_SOFT = 'rgba(124, 32, 244, 0.12)';
export const ACCENT_TINT = '#f3ebfe';
export const ACCENT_DEEP = '#5b14b8';
/** Link-style text for citations and the sources list. */
export const LINK = '#6419c9';
/** Citation pill fill on hover. */
export const LINK_BG_HOVER = '#ece0fd';
export const FONT_SANS = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

/**
 * Type scale — the sizes chat products have converged on (ChatGPT, Claude,
 * Linear): 15px reading text, 14px secondary UI, 13px dense data, 12/11px labels.
 */
export const FS = {
  body: '0.9375rem', // 15px — answer headline, composer
  sm: '0.875rem', // 14px — answer text, messages, list rows, buttons (side-panel standard)
  table: '0.8125rem', // 13px — tables and dense data
  label: '0.75rem', // 12px — metadata, captions
  micro: '0.6875rem', // 11px — eyebrows, tags
} as const;
/** Inter reads best with slight negative tracking at 14–16px. */
export const TRACKING = '-0.006em';

/** Above the Feedback tab and launcher (1250) so the open panel covers them. */
export const PANEL_Z = 1350;
/** Above the panel so source details open on top of it. */
export const DIALOG_Z = 1400;

/** Phones (portrait or landscape): the panel goes full screen. */
export const COMPACT_QUERY = '(max-width:600px), (max-height:500px)';
